module.exports = __webpack_public_path__ + "static/media/uni_logo_kcl.fc112c16.png";